export default "__VITE_ASSET__6e946ba5__"